import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { LocalCache } from '@nk/caching-lib';
import { CompanyRiskScoreAnalysisListByModel, CompanyRiskScoreGroupingEntity } from '@nk/data-entities-lib';

export interface BankruptcyRiskScoreApiService {
  companyRiskScoreGroupingListCache: LocalCache<this, () => Observable<CompanyRiskScoreGroupingEntity[]>>;
  companyRiskScoreAnalysisCollectionByModelCache: LocalCache<
    this,
    (companyUuid: string) => Observable<CompanyRiskScoreAnalysisListByModel>
  >;
  // TODO: move risk service to the company-block
}

export const BANKRUPTCY_RISK_SCORE_API_SERVICE_TOKEN = new InjectionToken<BankruptcyRiskScoreApiService>(
  'CompanyBankruptcyRiskScoreApiService',
);
